import './ChatModal.css'

import rheyaAvatar from '../assets/rheya-avatar.jpg'

export type ChatMinimizedProps = {
  onRestore: () => void
  onClose: () => void
}

export const ChatMinimized = (props: ChatMinimizedProps) => {
  const { onRestore, onClose } = props

  return (
    <div className="chat-modal--minimized" onClick={onRestore}>
      <header className="chat-modal__header">
        <div className="chat-modal__header-info">
          <img className="chat-modal__avatar" src={rheyaAvatar} alt="Rheya" />
          <div>
            <h2 className="chat-modal__title">Rheya</h2>
            <p className="chat-modal__subtitle">Your matchmaker</p>
          </div>
        </div>
        <div className="chat-modal__header-actions">
          <button
            type="button"
            className="chat-modal__close"
            onClick={(e) => {
              e.stopPropagation()
              onClose()
            }}
            aria-label="Close"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </header>
    </div>
  )
}
